import React, { useRef, useEffect, useState } from "react";

import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend } from 'chart.js';
import { Bar } from 'react-chartjs-2';

import { Dimmer } from "../../spinner";
import Footer from "../../Footer";
import moment from "moment";
import Axios from "axios";

import CardDasboard from "../../cardDasboard";

import axios from "axios";




ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);


const DasboardCaja = (props) => {
    let token = localStorage.getItem("jwtToken");
    const efiscalanio = JSON.parse(localStorage.getItem("efiscalanio"));
    const [titulo, setTitulo] = useState();
    const [actividadxCome, setActividadxCome] = useState();
    const [usuariow, setUsuariow] = useState();
    const [conexionWeb, setConexionWeb] = useState()
    const [cantidadDeclaracion, setCantidadDeclaracion] = useState([]);
    const [mensaje, setMensaje] = useState({
        mostrar: false,
        titulo: "",
        texto: "",
        icono: "",
    });
    const [mostrar5, setMostrar5] = useState(false);
    const [titulo1, setTitulo1] = useState();
    const [msg1, setMsg1] = useState();
    const [actividad, setActividad] = useState();
    const [comercio, setComercio] = useState();
    const [statusCome, setStatusCome] = useState();
    const [persona, setPersona] = useState();
    const [deuda, setDeuda] = useState();
    const [historico, setHistorico] = useState();
    const [multas, setMultas] = useState();
    const [facturasC, setFacturasC] = useState();
    const [retencion, setRetencion] = useState();
    const [deshabilitado, setDeshabilitado] = useState(false);
    const [inmuebleCome, setInmuebleCome] = useState();
    const [facturasPagadas, setFacturasPagadas] = useState();
    const [facturasPagadasEtax, setFacturasPagadasEtax] = useState();
    const [facturasOtrosPgosEtax, setFacturasOtrosPgosEtax] = useState();
    const [factorCambio, setFactorCambio] = useState(0);
    const [idComercio, setIdComercio] = useState(0);

    const [fechaSistema, setFechaSistema] = useState(
        localStorage.getItem("fechasistema")
    );
    const [activate, setActivate] = useState(false);
    let op = require("../../../modulos/datos");
    const espiritu = parseInt(JSON.parse(localStorage.getItem("espiritu")));
    const [labelsDeclarar, setLabelsDeclarar] = useState([]);
    const [cantidadLicencias, setCantidadLicencias] = useState([]);
    const [comercios, setComercios] = useState([])
    const [mesdeclaxDia, setMesDeclaxDia] = useState(
        moment.utc(JSON.parse(localStorage.getItem("fechasistema"))).format("MM")
    );
    const [show, setShow] = useState(false)
    const [values, setValues] = useState()
    const [totales, setTotales] = useState({
        activos: 0,
        inactivos: 0,
        total: 0,
    });
    const [totalDeclarar, setTotalesDeclarar] = useState({
        oficina: 0,
        web: 0,
    });
    const [totalDeclararxDia, setTotalesDeclararxDia] = useState({
        dia: "",
        cantidad: "",
        cantidad2: "",
    });

    const contriData = {
        labels: labelsDeclarar,
        datasets:
            espiritu === 0 && efiscalanio < 2022
                ? [
                    {
                        label: "Cantidad",
                        data: cantidadDeclaracion,
                        backgroundColor: "rgb(57, 102, 147)",
                    },
                ]
                : [
                    {
                        label: "Total Declarados",
                        data: cantidadDeclaracion,
                        backgroundColor: "rgb(71, 143, 214)",
                    },
                    /*   {
                        label: "2da Quincena",
                        data: cantidadDeclaracion2,
                        backgroundColor: "rgba(53, 162, 235)",
                      }, */
                ],
    };
    const contri = {
        responsive: true,
        plugins: {
            legend: {
                position: "top",
            },
            /*  title: {
                 display: true,
                 text: "Chart.js Bar Chart",
             }, */
        },
    };

    const declaDiarias = {
        responsive: true,
        plugins: {
            legend: {
                position: "top",
            },
            /*  title: {
                 display: true,
                 text: "Chart.js Bar Chart",
             }, */
        },
    };

    const declaDiariaData = {
        labels: totalDeclararxDia.dia,
        datasets:
            espiritu === 0 && efiscalanio < 2022
                ? [
                    {
                        label: "Cantidad",
                        data: totalDeclararxDia.cantidad,
                        backgroundColor: "rgb(57, 102, 147)",
                    },
                ]
                : [
                    {
                        label: "Total Declaraciones",
                        data: totalDeclararxDia.cantidad,
                        backgroundColor: "rgb(71, 143, 214)",
                    },
                    /* {
                      label: "2da Quincena",
                      data: totalDeclararxDia.cantidad2,
                      backgroundColor: "rgba(53, 162, 235)",
                    }, */
                ],
    };

    const [searchTerm, setSearchTerm] = useState('');


    const handleSearchChange = (event) => {
        setSearchTerm(event.target.value);
    };


    const filteredComercios = comercios.filter((comercio) =>
        comercio.nombre.toLowerCase().includes(searchTerm.toLowerCase()) ||
        comercio.direccion.toLowerCase().includes(searchTerm.toLowerCase())
    );

    const seleccionarRegistros = () => {
        /* para los datos de la tabla */
        let campos = "codigocatastral, idcomercio, nombre, rif, ritm, reprelegal,fechainscripcion,cuenta, direccion, esagentereten, actualizado	,status,credito";
        let nomtab = "comercio";
        let orden = "idcomercio";
        setActivate(true);
        let endpoint =
            op.conexion +
            `/api/comun/seleccionaregistros?campos=${campos}&nomtab=${nomtab}&orden=${orden}`;


        Axios
            .get(endpoint, {
                headers: {
                    "x-access-token": `${token}`,
                    'Content-Type': 'application/json'
                },
            })
            .then((response) => {
                if (response.status == 200) {
                    let totalContri = 0;
                    let totalActivos = 0;
                    let totalInactivos = 0;

                    setComercios(response.data)

                    for (let x = 0; x < response.data.length; x++) {
                        totalContri = totalContri + 1;
                        /*  console.log(response.data[x].status) */
                        if (response.data[x].status === "51") {
                            totalActivos = totalActivos + 1;
                        } else if (response.data[x].status === "52") {
                            totalInactivos = totalInactivos + 1;
                        }
                    }

                    console.log(totalContri, totalActivos, totalInactivos);

                    setTotales({
                        activos: totalActivos,
                        inactivos: totalInactivos,
                        total: totalContri,
                    });
                    setActivate(false);

                }
            })
            .catch((error) => {
                /*  if( error && error.response){
                     setMensaje({
                     mostrar: true,
                     titulo: "ERROR",
                     texto: error,
                     icono: "error",
                 });} */
                setActivate(false);

                setActivate(false);
            });
    };

    const seleccionarDeclaxDiasEspiritu1 = (mes) => {
        /* para los datos de la tabla */

        setActivate(true);

        let endpoint =
            op.conexion +
            `/api/industria/declaracionesdiariasespiritu1?mes=${mes}&anio=${efiscalanio}`;


        Axios
            .get(endpoint, {
                headers: {
                    "x-access-token": `${token}`,
                    'Content-Type': 'application/json'
                },
            })
            .then((response) => {
                if (response.status == 200) {
                    setActivate(false);
                    console.log(response.data);

                    let dia = [];
                    let cantidad = [];
                    let cantidad2 = [];

                    for (let x = 0; x < response.data.length; x++) {
                        let valor = {};

                        if (!dia.includes(response.data[x].dia)) {
                            dia.push(response.data[x].dia);
                        }

                        for (let i = 0; i < response.data.length; i++) {
                            if (
                                response.data[x].dia === response.data[i].dia &&
                                parseInt(response.data[i].tipo) === 3
                            ) {
                                cantidad.push(response.data[i].total);
                            }
                        }

                        for (let i = 0; i < response.data.length; i++) {
                            if (
                                response.data[x].dia === response.data[i].dia &&
                                parseInt(response.data[i].tipo) === 4
                            ) {
                                cantidad2.push(response.data[i].total);
                            }
                        }
                    }

                    console.log(dia);

                    console.log(cantidad);
                    console.log(cantidad2);

                    setTotalesDeclararxDia({
                        dia: dia,
                        cantidad: cantidad,
                        cantidad2: cantidad2,
                    });
                }
            })
            .catch((error) => {
                /*  if( error && error.response){
                     setMensaje({
                     mostrar: true,
                     titulo: "ERROR",
                     texto: error,
                     icono: "error",
                 });} */
                setActivate(false);

                setActivate(false);
            });
    };

    const seleccionarLicencias = () => {
        /* para los datos de la tabla */
        let campos = "fechaemision";
        let nomtab = "licenciaxcomercio";
        let nomid = "anio";
        console.log('licenciaxcomercio')

        let endpoint =
            op.conexion +
            `/api/consulta/modelirows?campos=${campos}&nomtab=${nomtab}&id=${efiscalanio}&nomid=${nomid}`;


        Axios
            .get(endpoint, {
                headers: {
                    "x-access-token": `${token}`,
                    'Content-Type': 'application/json'
                },
            })
            .then((response) => {
                if (response.status == 200) {
                    setActivate(false);

                    let enero = 0;
                    let febrero = 0;
                    let marzo = 0;
                    let abril = 0;
                    let mayo = 0;
                    let junio = 0;
                    let julio = 0;
                    let agosto = 0;
                    let septiembre = 0;
                    let octubre = 0;
                    let noviembre = 0;
                    let diciembre = 0;

                    for (let i = 0; i < response.data.length; i++) {
                        if (parseInt(response.data[i].fechaemision.substring(5, 7)) === 1) {
                            enero = enero + 1;
                        } else if (
                            parseInt(response.data[i].fechaemision.substring(5, 7)) === 2
                        ) {
                            febrero = febrero + 1;
                        } else if (
                            parseInt(response.data[i].fechaemision.substring(5, 7)) === 3
                        ) {
                            marzo = marzo + 1;
                        } else if (
                            parseInt(response.data[i].fechaemision.substring(5, 7)) === 4
                        ) {
                            abril = abril + 1;
                        } else if (
                            parseInt(response.data[i].fechaemision.substring(5, 7)) === 5
                        ) {
                            mayo = mayo + 1;
                        } else if (
                            parseInt(response.data[i].fechaemision.substring(5, 7)) === 6
                        ) {
                            junio = junio + 1;
                        } else if (
                            parseInt(response.data[i].fechaemision.substring(5, 7)) === 7
                        ) {
                            julio = julio + 1;
                        } else if (
                            parseInt(response.data[i].fechaemision.substring(5, 7)) === 8
                        ) {
                            agosto = agosto + 1;
                        } else if (
                            parseInt(response.data[i].fechaemision.substring(5, 7)) === 9
                        ) {
                            septiembre = septiembre + 1;
                        } else if (
                            parseInt(response.data[i].fechaemision.substring(5, 7)) === 10
                        ) {
                            octubre = octubre + 1;
                        } else if (
                            parseInt(response.data[i].fechaemision.substring(5, 7)) === 11
                        ) {
                            noviembre = noviembre + 1;
                        } else if (
                            parseInt(response.data[i].fechaemision.substring(5, 7)) === 12
                        ) {
                            diciembre = diciembre + 1;
                        }
                    }

                    setCantidadLicencias(response.data.length);
                    setLabelsLicencias([
                        enero !== 0 ? "Enero" : "",
                        febrero !== 0 ? "Febrero" : "",
                        marzo !== 0 ? "Marzo" : "",
                        abril !== 0 ? "Abril" : "",
                        mayo !== 0 ? "Mayo" : "",
                        junio !== 0 ? "Junio" : "",
                        julio !== 0 ? "Julio" : "",
                        agosto !== 0 ? "Agosto" : "",
                        septiembre !== 0 ? "Septiembre" : "",
                        octubre !== 0 ? "Octubre" : "",
                        noviembre !== 0 ? "Noviembre" : "",
                        diciembre !== 0 ? "Diciembre" : "",
                    ]);
                }
            })
            .catch((error) => {
                /* if(error && error.response.data.message){
                  setMensaje({
                    mostrar: true,
                    titulo: "ERROR",
                    texto: error.response.data.me
                    ssage,
                    icono: "error",
                  });
                } */

                setActivate(false);

            });
    };
    const seleccionarDeclaraciones = (mes) => {
        /* para los datos de la tabla */


        let campos = "idfactura";
        let nomtab = "djurada";
        let nomid = "anio";
        let nomid2 = "nummes";
        let orden = "fechadeclaracion";

        let endpoint =
            op.conexion +
            `/api/consulta/idsstring2rows?campos=${campos}&nomtab=${nomtab}&id=${efiscalanio}&nomid=${nomid}&id2=${parseInt(
                mes.toString()
            )}&nomid2=${nomid2}&orden=${orden}`;


        Axios
            .get(endpoint, {
                headers: {
                    "x-access-token": `${token}`,
                    'Content-Type': 'application/json'

                },
            })
            .then((response) => {
                if (response.status == 200) {


                    let oficina = 0;
                    let web = 0;

                    for (let x = 0; x < response.data.length; x++) {
                        console.log(response.data[x].idfactura);

                        if (response.data[x].idfactura === null) {
                            oficina = oficina + 1;
                        } else {
                            web = web + 1;
                        }
                    }

                    setTotalesDeclarar({
                        oficina: oficina,
                        web: web,
                    });
                }
            })
            .catch((error) => {
                /*  if( error && error.response){
                     setMensaje({
                     mostrar: true,
                     titulo: "ERROR",
                     texto: error,
                     icono: "error",
                 });} */
                setActivate(false);

                setActivate(false);
            });
    };

    const seleccionarDeclaracionesxDias = (mes) => {
        /* para los datos de la tabla */

        setActivate(true);

        let endpoint =
            op.conexion +
            `/api/industria/declaracionesdiarias?mes=${mes}&anio=${efiscalanio}`;


        Axios
            .get(endpoint, {
                headers: {
                    "x-access-token": `${token}`,
                    'Content-Type': 'application/json'

                },
            })
            .then((response) => {
                if (response.status == 200) {
                    setActivate(false);
                    console.log(response.data);

                    let dia = [];
                    let cantidad = [];

                    for (let x = 0; x < response.data.length; x++) {
                        dia.push("Dia " + response.data[x].dia.toString() + ": ");
                        cantidad.push(response.data[x].total);
                        console.log(
                            response.data[x].dia.toString(),
                            ": ",
                            parseInt(response.data[x].total)
                        );
                    }

                    console.log(dia);

                    console.log(cantidad);

                    setTotalesDeclararxDia({
                        dia: dia,
                        cantidad: cantidad,
                    });
                }
            })
            .catch((error) => {
                /*  if( error && error.response){
                     setMensaje({
                     mostrar: true,
                     titulo: "ERROR",
                     texto: error,
                     icono: "error",
                 });} */
                setActivate(false);

                setActivate(false);
            });
    };
    const onChange2 = (e) => {
        setMesDeclaxDia(e.target.value);
        if (espiritu === 0 && efiscalanio >= 2022) {
            seleccionarDeclaxDiasEspiritu1(e.target.value);
        } else {
            seleccionarDeclaracionesxDias(e.target.value);
        }
    };
    const seleccionarDeclaEspiritu1 = () => {
        setActivate(true);
        let endpoint =
            op.conexion +
            `/api/industria/contrideclaradosespiritu1?anio=${efiscalanio}`;


        Axios
            .get(endpoint, {
                headers: {
                    "x-access-token": `${token}`,
                    'Content-Type': 'application/json'
                },
            })
            .then((response) => {
                if (response.status == 200) {
                    setActivate(false);

                    console.log("si paso");
                    let enero = 0;
                    let febrero = 0;
                    let marzo = 0;
                    let abril = 0;
                    let mayo = 0;
                    let junio = 0;
                    let julio = 0;
                    let agosto = 0;
                    let septiembre = 0;
                    let octubre = 0;
                    let noviembre = 0;
                    let diciembre = 0;
                    let enero2 = 0;
                    let febrero2 = 0;
                    let marzo2 = 0;
                    let abril2 = 0;
                    let mayo2 = 0;
                    let junio2 = 0;
                    let julio2 = 0;
                    let agosto2 = 0;
                    let septiembre2 = 0;
                    let octubre2 = 0;
                    let noviembre2 = 0;
                    let diciembre2 = 0;

                    for (let i = 0; i < response.data.length; i++) {
                        if (parseInt(response.data[i].mes) === 1) {
                            if (parseInt(response.data[i].tipo) === 3) {
                                enero = enero + 1;
                            } else {
                                enero2 = enero2 + 1;
                            }
                        } else if (parseInt(response.data[i].mes) === 2) {
                            if (parseInt(response.data[i].tipo) === 3) {
                                febrero = febrero + 1;
                            } else {
                                febrero2 = febrero2 + 1;
                            }
                        } else if (parseInt(response.data[i].mes) === 3) {
                            if (parseInt(response.data[i].tipo) === 3) {
                                marzo = marzo + 1;
                            } else {
                                marzo2 = marzo2 + 1;
                            }
                        } else if (parseInt(response.data[i].mes) === 4) {
                            if (parseInt(response.data[i].tipo) === 3) {
                                abril = abril + 1;
                            } else {
                                abril2 = abril2 + 1;
                            }
                        } else if (parseInt(response.data[i].mes) === 5) {
                            if (parseInt(response.data[i].tipo) === 3) {
                                mayo = mayo + 1;
                            } else {
                                mayo2 = mayo2 + 1;
                            }
                        } else if (parseInt(response.data[i].mes) === 6) {
                            if (parseInt(response.data[i].tipo) === 3) {
                                junio = junio + 1;
                            } else {
                                junio2 = junio2 + 1;
                            }
                        } else if (parseInt(response.data[i].mes) === 7) {
                            if (parseInt(response.data[i].tipo) === 3) {
                                julio = julio + 1;
                            } else {
                                julio2 = julio2 + 1;
                            }
                        } else if (parseInt(response.data[i].mes) === 8) {
                            if (parseInt(response.data[i].tipo) === 3) {
                                agosto = agosto + 1;
                            } else {
                                agosto2 = agosto2 + 1;
                            }
                        } else if (parseInt(response.data[i].mes) === 9) {
                            if (parseInt(response.data[i].tipo) === 3) {
                                septiembre = septiembre + 1;
                            } else {
                                septiembre2 = septiembre2 + 1;
                            }
                        } else if (parseInt(response.data[i].mes) === 10) {
                            if (parseInt(response.data[i].tipo) === 3) {
                                octubre = octubre + 1;
                            } else {
                                octubre2 = octubre2 + 1;
                            }
                        } else if (parseInt(response.data[i].mes) === 11) {
                            if (parseInt(response.data[i].tipo) === 3) {
                                noviembre = noviembre + 1;
                            } else {
                                noviembre2 = noviembre2 + 1;
                            }
                        } else if (parseInt(response.data[i].mes) === 12) {
                            if (parseInt(response.data[i].tipo) === 3) {
                                diciembre = diciembre + 1;
                            } else {
                                diciembre2 = diciembre2 + 1;
                            }
                        }
                    }

                    setCantidadDeclaracion([
                        enero,
                        febrero,
                        marzo,
                        abril,
                        mayo,
                        junio,
                        julio,
                        agosto,
                        septiembre,
                        octubre,
                        noviembre,
                        diciembre,
                    ]);
                    setCantidadDeclaracion2([
                        enero2,
                        febrero2,
                        marzo2,
                        abril2,
                        mayo2,
                        junio2,
                        julio2,
                        agosto2,
                        septiembre2,
                        octubre2,
                        noviembre2,
                        diciembre2,
                    ]);

                    setLabelsDeclarar([
                        enero !== 0 ? "Enero" : "",
                        febrero !== 0 ? "Febrero" : "",
                        marzo !== 0 ? "Marzo" : "",
                        abril !== 0 ? "Abril" : "",
                        mayo !== 0 ? "Mayo" : "",
                        junio !== 0 ? "Junio" : "",
                        julio !== 0 ? "Julio" : "",
                        agosto !== 0 ? "Agosto" : "",
                        septiembre !== 0 ? "Septiembre" : "",
                        octubre !== 0 ? "Octubre" : "",
                        noviembre !== 0 ? "Noviembre" : "",
                        diciembre !== 0 ? "Diciembre" : "",
                    ]);
                }
            })
            .catch((error) => {
                /*  setMensaje({
                   mostrar: true,
                   titulo: "ERROR",
                   texto: error,
                   icono: "error",
                 }); */
                setActivate(false);

                setActivate(false);
            });
    };

    const seleccionarContriDeclarados = () => {
        setActivate(true);
        let endpoint =
            op.conexion + `/api/industria/contrideclarados?anio=${efiscalanio}`;


        Axios
            .get(endpoint, {
                headers: {
                    "x-access-token": `${token}`,
                    'Content-Type': 'application/json'
                },
            })
            .then((response) => {
                if (response.status == 200) {
                    setActivate(false);

                    console.log("si paso");
                    let enero = 0;
                    let febrero = 0;
                    let marzo = 0;
                    let abril = 0;
                    let mayo = 0;
                    let junio = 0;
                    let julio = 0;
                    let agosto = 0;
                    let septiembre = 0;
                    let octubre = 0;
                    let noviembre = 0;
                    let diciembre = 0;

                    for (let i = 0; i < response.data.length; i++) {
                        if (parseInt(response.data[i].mes) === 1) {
                            enero = enero + 1;
                        } else if (parseInt(response.data[i].mes) === 2) {
                            febrero = febrero + 1;
                        } else if (parseInt(response.data[i].mes) === 3) {
                            marzo = marzo + 1;
                        } else if (parseInt(response.data[i].mes) === 4) {
                            abril = abril + 1;
                        } else if (parseInt(response.data[i].mes) === 5) {
                            mayo = mayo + 1;
                        } else if (parseInt(response.data[i].mes) === 6) {
                            junio = junio + 1;
                        } else if (parseInt(response.data[i].mes) === 7) {
                            julio = julio + 1;
                        } else if (parseInt(response.data[i].mes) === 8) {
                            agosto = agosto + 1;
                        } else if (parseInt(response.data[i].mes) === 9) {
                            septiembre = septiembre + 1;
                        } else if (parseInt(response.data[i].mes) === 10) {
                            octubre = octubre + 1;
                        } else if (parseInt(response.data[i].mes) === 11) {
                            noviembre = noviembre + 1;
                        } else if (parseInt(response.data[i].mes) === 12) {
                            diciembre = diciembre + 1;
                        }
                    }

                    setCantidadDeclaracion([
                        enero,
                        febrero,
                        marzo,
                        abril,
                        mayo,
                        junio,
                        julio,
                        agosto,
                        septiembre,
                        octubre,
                        noviembre,
                        diciembre,
                    ]);
                    setLabelsDeclarar([
                        enero !== 0 ? "Enero" : "",
                        febrero !== 0 ? "Febrero" : "",
                        marzo !== 0 ? "Marzo" : "",
                        abril !== 0 ? "Abril" : "",
                        mayo !== 0 ? "Mayo" : "",
                        junio !== 0 ? "Junio" : "",
                        julio !== 0 ? "Julio" : "",
                        agosto !== 0 ? "Agosto" : "",
                        septiembre !== 0 ? "Septiembre" : "",
                        octubre !== 0 ? "Octubre" : "",
                        noviembre !== 0 ? "Noviembre" : "",
                        diciembre !== 0 ? "Diciembre" : "",
                    ]);
                }
            })
            .catch((error) => {
                /* setMensaje({
                  mostrar: true,
                  titulo: "ERROR",
                  texto: error,
                  icono: "error",
                });
                setActivate(false); */

                setActivate(false);
            });
    };

    const cerrarModalActualizar = () => {
        setComercio();
        setActividad();
        setActividadxCome();
        setInmuebleCome();

        setUsuariow();
        setPersona();
        setMostrar5(false);

        setFacturasPagadasEtax()
        setFacturasOtrosPgosEtax()
    };
    const validarActuComercio = () => {
        setComercio();
        setActividad();
        setActividadxCome();
        setInmuebleCome();
        setUsuariow();
        setPersona();
        setMostrar5(false);
        window.location.href = "/comercio";
    };

    const seleccionarFactorCambio = () => {
        let endpoint = `${op.conexion}/api/vehiculo/factorcambio`;


        axios
            .get(endpoint, {
                headers: {
                    "x-access-token": `${token}`,
                    'Content-Type': 'application/json'

                },
            })
            .then(function (response) {
                if (response.status == 200) {
                    console.log(response.data);
                    setFactorCambio(response.data.valor);
                }
            })
            .catch(function (error) {
                setMensaje({
                    mostrar: true,
                    titulo: "ERROR",
                    texto: error,
                    icono: "error",
                });

            });
    };

    const seleccionarConexionWeb = () => {



        let campos = '*';
        let nomtab = 'basedatos';
        let condi = "tipo = 'web'";
        let orden = 'idbasedatos';
        let endpoint = `${op.conexion}/api/consulta/selecionarregistrocondi?campos=${campos}&nomtab=${nomtab}&condi=${condi}&orden=${orden}`;
        axios.get(endpoint, {
            headers: {
                "x-access-token": `${token}`,
                'Content-Type': 'application/json'

            },
        }).then(function (response) {

            if (response.status == 200) {

                console.log(response.data[0]);
                setConexionWeb(response.data[0])

            }
            setActivate(false);

        }).catch(function (error) {

            setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });
            setActivate(false);

        })
    };

    useEffect(() => {
        seleccionarConexionWeb()
        let mes = parseInt(
            moment.utc(JSON.parse(localStorage.getItem("fechasistema"))).format("MM")
        );
        let efiscalanio = parseInt(JSON.parse(localStorage.getItem("efiscalanio")));
        let espiritu = parseInt(JSON.parse(localStorage.getItem("espiritu")));
        seleccionarRegistros();
        seleccionarLicencias();
        seleccionarDeclaraciones(mes);
        seleccionarFactorCambio()
        if (espiritu === 0 && efiscalanio >= 2022) {
            seleccionarDeclaxDiasEspiritu1(mes);
            seleccionarDeclaEspiritu1();
        } else {
            seleccionarDeclaracionesxDias(mes);
            seleccionarContriDeclarados();
        }
    }, []);

    const seleccionarFacturasPagasEtax = (rif) => {

        let endpoint = `${op.conexion}/api/industria/allpagosetax?rif='${rif ? rif.trim() : ''}'`;

        console.log('aqui el rif   ->' + rif)
        axios
            .get(endpoint, {
                headers: {
                    "x-access-token": `${token}`,
                    'Content-Type': 'application/json'

                },
            })
            .then(function (response) {
                if (response.status == 200) {
                    console.log("decima consulta facturas etax");



                    const pago = response.data.filter(item => item.tipo === 6);

                    const otroPago = response.data.filter(item => item.tipo !== 6);


                    console.log('pago: ->' + pago);

                    console.log('otro pagp: ->' + otroPago);


                    setFacturasPagadasEtax(pago);

                    setFacturasOtrosPgosEtax(otroPago);
                    console.log(response.data);
                    setActivate(false);
                    setMostrar5(true)

                }
            })
            .catch(function (error) {
                /*  setMensaje({
                   mostrar: true,
                   titulo: "ERROR",
                   texto: error,
                   icono: "error",
                 }); */
                console.log(error.response.data.message);
            });
    };

    const seleccionarRetenciones = (idcomercio, item) => {
        let endpoint = `${op.conexion}/api/industria/allretenciones`;
        console.log(endpoint)
        console.log("8");

        let body = {
            ip: conexionWeb.ip,
            nombre: conexionWeb.nombre,
            contrasena: conexionWeb.contraseña,
            puerto: conexionWeb.puerto,
            idcomercio: idcomercio
        }

        axios
            .post(endpoint, body, {
                headers: {
                    "x-access-token": `${token}`,
                    'Content-Type': 'application/json'

                },
            })
            .then(function (response) {
                if (response.status == 200) {
                    console.log(response.data);
                    setRetencion(response.data);
                    seleccionarFacturasPagas(idcomercio, item);




                }
            })
            .catch(function (error) {
                setMensaje({
                    mostrar: true,
                    titulo: "ERROR",
                    texto: error,
                    icono: "error",
                });

                setActivate(false);
            });
    };

    const seleccionarFacturasPagas = (idcomercio, item) => {
        let endpoint = `${op.conexion}/api/industria/facturaspagadas?idcomercio=${idcomercio}`;
       
        console.log('7');


        axios
            .get(endpoint, {
                headers: {
                    "x-access-token": `${token}`,
                    'Content-Type': 'application/json'

                },
            })
            .then(function (response) {
                if (response.status == 200) {

                    setFacturasPagadas(response.data);
                    seleccionarFacturasPagasEtax(item.rif)

                }
            })
            .catch(function (error) {
                setMensaje({
                    mostrar: true,
                    titulo: "ERROR",
                    texto: error,
                    icono: "error",
                });

                setActivate(false);
            });
    };

    const seleccionarMultas = (idcomercio, esagente, item) => {
        console.log('6')

        let camp = "idmulta, fechamulta, descripcion, concepto, monto, cancelada";
        let tabla = "multa";
        let nombreid = "idcontribuyente";
        let nombreid2 = "tablacontribuyente";
        let valorid2 = "comercio";
        let nombreid3 = "tipoimpuesto";
        let valorid3 = "ACTIVIDADES ECONOMICAS";
        let endpoint = `${op.conexion}/api/consulta/modeli3string?campos=${camp}&id=${idcomercio}&nomtab=${tabla}&nomid=${nombreid}&nomid2=${nombreid2}&id2=${valorid2}&nomid3=${nombreid3}&id3=${valorid3}`;

        axios
            .get(endpoint, {
                headers: {
                    "x-access-token": `${token}`,
                    'Content-Type': 'application/json'

                },
            })
            .then(function (response) {
                if (response.status == 200) {
                    console.log("6");

                    setMultas(response.data);
                    if (esagente && conexionWeb !== '') {
                        // seleccionarRetenciones(idcomercio)
                        seleccionarRetenciones(idComercio, item);

                    } else {
                        seleccionarFacturasPagas(idcomercio, item);

                    }

                }



            })
            .catch(function (error) {
                setMensaje({
                    mostrar: true,
                    titulo: "ERROR",
                    texto: error,
                    icono: "error",
                });

                setActivate(false);
            });
    };

    const SelectDeudaC = (idcomercio, fecha, espiritu, esagente, item) => {
        console.log(idcomercio, fecha, espiritu, esagente, item)
        let endpoint = `${op.conexion}/api/industria/deudacomercio?idcomercio=${idcomercio}&fecha=${fecha}&espiritu=${espiritu}&tipounid=${1}`;
        console.log(endpoint)
        console.log("5");

        axios
            .get(endpoint, {
                headers: {
                    "x-access-token": `${token}`,
                    'Content-Type': 'application/json'

                },
            })
            .then(function (response) {
                if (response.status == 200) {

                    console.log('entre aqui en SelectDeudaC')
                    var deu = [];
                    var his = [];
                    for (let i = 0; i < response.data.length; i++) {
                        if (response.data[i].fechapago === null) {
                            deu.push({
                                anio: response.data[i].anio,
                                mes: response.data[i].mes.replace("'", "").replace("'", ""),
                                //monto: response.data[i].mondeu * factorCambio,
                                monto: response.data[i].mondeu,
                                intereses: response.data[i].intmoradeu,
                                recargo: response.data[i].recargodeu,
                                multa: response.data[i].multa,
                                retenciones: response.data[i].retencion,
                                credito: response.data[i].acreditacion,
                                totalperi: response.data[i].subtotal,
                                status: response.data[i].estatus,
                                idfac: response.data[i].idfact,
                                nummes: response.data[i].nmes,
                                estatusfac: response.data[i].estatusfac,
                                tipotransaccion: response.data[i].tipotransaccion,
                            });
                        } else {
                            his.push({
                                anio: response.data[i].anio,
                                mes: response.data[i].mes.replace("'", "").replace("'", ""),
                                monto: response.data[i].mondeu,
                                intereses: response.data[i].intmoradeu,
                                recargo: response.data[i].recargodeu,
                                multa: response.data[i].multa,
                                descuento: response.data[i].mondescue,
                                recibo: response.data[i].numreci,
                                fechapago: response.data[i].fechapago,
                                status: response.data[i].estatus,
                                idfac: response.data[i].idfact,
                                estatusfac: response.data[i].estatusfac,
                                tipotransaccion: response.data[i].tipotransaccion,
                            });
                        }
                    }

                    setDeuda(deu);
                    setHistorico(his);
                seleccionarMultas(idcomercio, esagente, item);


                }
                //  SelectPagoWeb(idcomercio, esagente);
//                seleccionarMultas(idcomercio, esagente, item);

            })
            .catch(function (error) {
                console.log(error)
                setMensaje({
                    mostrar: true,
                    titulo: "ERROR",
                    texto: error,
                    icono: "error",
                });

                setActivate(false);
            });
    };


    const SelectInmueble = (idinmueble, idcomercio, esagente, item) => {
        let endpoint = `${op.conexion}/api/industria/inmueblexcomercio?idinmueble=${idinmueble}`;


        axios
            .get(endpoint, {
                headers: {
                    "x-access-token": `${token}`,
                    'Content-Type': 'application/json'

                },
            })
            .then(function (response) {
                if (response.status == 200) {
                    console.log("4");


                    if (response.data) {
                        setInmuebleCome(response.data);
                    }
                   

                    SelectDeudaC(idcomercio, fechaSistema, espiritu, esagente, item);


                }
            })
            .catch(function (error) {
                setMensaje({
                    mostrar: true,
                    titulo: "ERROR",
                    texto: error,
                    icono: "error",
                });

                setActivate(false);
            });


    };

    const SelectActividadComercio = (idcomercio, anio, idinmueble, esagente, item) => {
        let endpoint = `${op.conexion}/api/industria/actividadxcomercio?idcomercio=${idcomercio}&anio=${anio}`;

        axios
            .get(endpoint, {
                headers: {
                    "x-access-token": `${token}`,
                    'Content-Type': 'application/json'

                },
            })
            .then((response) => {
                if (response.status == 200) {
                    console.log("3");

                    if (response.data.length > 0) {
                        var axc = [];
                        for (let i = 0; i < response.data.length; i++) {
                            axc.push({
                                alicuota: response.data[i].alicuota,
                                codigoactividad: response.data[i].codigoactividad,
                                codigociu: response.data[i].codigociu,
                                descripcion: response.data[i].descripcion,
                                idactividad: response.data[i].idactividad,
                                minimo: response.data[i].minimo,
                            });
                        }

                        setActividadxCome(axc);
                    }
                  
                    SelectInmueble(idinmueble, idcomercio, esagente, item);

                }
            })
            .catch((error) => {

                setActivate(false);
            });

    };

    const SelectActividad = (idcomercio, idactividad, idinmueble, esagente, item) => {
        let endpoint = `${op.conexion}/api/industria/actividad?idactividad=${idactividad}`;

        axios
            .get(endpoint, {
                headers: {
                    "x-access-token": `${token}`,
                    'Content-Type': 'application/json'

                },
            })
            .then((response) => {
                if (response.status == 200) {
                    console.log("2");

                    if (response.data.length > 0) {

                        setActividad(response.data);
                    }

                    SelectActividadComercio(idcomercio, parseInt(localStorage.getItem("efiscalanio")), idinmueble, esagente, item);

                }

            })
            .catch((error) => {
                setMensaje({
                    mostrar: true,
                    titulo: "ERROR",
                    texto: error.response.data.message,
                    icono: "error",
                });

                setActivate(false);
            });

    };

    const SelectComercio = (idcomercio, item) => {
        let endpoint = `${op.conexion}/api/industria/comerciopersona?idcomercio=${idcomercio}`;
        setActivate(true)
        axios
            .get(endpoint, {
                headers: {
                    "x-access-token": `${token}`,
                    'Content-Type': 'application/json'

                },
            })
            .then((response) => {
                if (response.status == 200) {
                    setComercio(response.data);
                    console.log("1");

                    let idactividad = !response.data || response.data.idactividad === null ? 0 : response.data.idactividad;
                    let idinmueble = !response.data || response.data.idinmueble === null ? 0 : response.data.idinmueble;
                    let esagente = !response.data || response.data.esagentereten === null ? false : response.data.esagentereten;
                    if (response.data.idcomercio > 0) {
                        setPersona({
                            cedula: response.data.cedula,
                            nombres: response.data.nombres,
                            apellidos: response.data.apellidos,
                            correoe: response.data.correoe,
                            tlf1: response.data.tlf1,
                            tlf2: response.data.tlf2,
                            fnacimiento: response.data.fnacimiento,
                            nacionalidad: response.data.nacionalidad,
                            sexo: response.data.sexo,
                            direccion: response.data.direccionp,
                        });
                        SelectActividad(idcomercio, idactividad, idinmueble, esagente, item);

                    } else {

                        setActivate(false);
                    }


                }
            })
            .catch((error) => {
                setMensaje({
                    mostrar: true,
                    titulo: "ERROR",
                    texto: error,
                    icono: "error",
                });

                setActivate(false);
            });
    };


    const hola = (e) => {
        e.preventDefault()
        alert('hola desde la carta')

    }

    const consultarComercio = (item) => (e) => {
        e.preventDefault()
        setShow(true)
        setIdComercio(item.idcomercio);

        SelectComercio(item.idcomercio, item);


    }

    return (
        <div className=" mx-auto w-100 h-100 row py-4">
            <Dimmer active={activate} inverted>

            </Dimmer>
            <div className="col-md-12 mx-auto  h-100 row px-0">

     
            <div className="dashboard-grid">

               
                    <CardDasboard titulo={'Contribuyentes Atendidos'} icon={'fas fa-users me-2'}  tipo={1} />

                    <CardDasboard titulo={'Trasacciones del Dia'} icon={'fas fa-calendar-day me-2'}  tipo={1} />

                    <CardDasboard titulo={'Trasacciones Reversadas'} icon={'fas fa-history me-2'}  tipo={2} />

                    <CardDasboard titulo={'Movimientos Bancarios'} icon={'fas fa-piggy-bank me-2'}  tipo={1} />


                </div>

                <div className="col-md-12 row mx-auto py-2" /* style={{ top: -100 }} */>
                    <div className="col-md-6 mx-auto mt-0">
                        <div className="col-md-12 row rounded-card py-3 mx-auto bg-card-azul">
                            <h3 className="fw-bold px-4 row text-azul">
                                {" "}
                                Transacciones x Diarias


                             {/*    <select class="form-select form-select-sm ml-auto rounded-pill col-md-6"
                                    aria-label="Default select example"
                                    value={parseInt(mesdeclaxDia)}
                                    onChange={onChange2}
                                >
                                    <option value="1">Enero</option>
                                    <option value="2">Febrero</option>
                                    <option value="3">Marzo</option>
                                    <option value="4">Abril</option>
                                    <option value="5">Mayo</option>
                                    <option value="6">Junio</option>
                                    <option value="7">Julio</option>
                                    <option value="8">Agosto</option>
                                    <option value="9">Septiembre</option>
                                    <option value="10">Octubre</option>
                                    <option value="11">Noviembre</option>
                                    <option value="12">Diciembre</option>
                                </select> */}

                            </h3>

                            <div className="col-md-12 px-0 mx-auto">
                                <Bar options={declaDiarias} data={declaDiariaData} />


                            </div>

                        </div>

                    </div>

                    <div className="col-md-6 mx-auto mt-0">
                        <div className="col-md-12 row rounded-card py-3 mx-auto bg-card-azul">
                            <h3 className="fw-bold  text-azul">
                                {" "}
                                Contribuyentes x Dia
                            </h3>

                            <div className="col-md-12 px-0 mx-auto">
                                <Bar options={contri} data={contriData} />
                            </div>
                        </div>
                    </div>
                </div>


            </div>
         

            {/* <div className="col-md-9 bg-primary mx-auto h-50"></div> */}
            <Footer />
        </div>
    );
};

export default DasboardCaja;
